import { ClientPinRoomResponse } from "../../proto/ClientPinRoom_pb";
import store from "../../store";
import { addRooms, editRoom } from "../../store/rooms/actions";
import BaseHandler from "../BaseHandler";
import { ClientResolveUsernameResponse } from "../../proto/ClientResolveUsername_pb";
import { addUsers } from "../../store/users/actions";

export default class HandleClientResolveUsernameResponse extends BaseHandler<ClientResolveUsernameResponse> {
  handle() {
    const clientResolveUsernameResponse = this.response.toObject();
    if (clientResolveUsernameResponse.room) store.dispatch(addRooms([clientResolveUsernameResponse.room]));
    else if (clientResolveUsernameResponse.user) store.dispatch(addUsers([clientResolveUsernameResponse.user]));
  }
}
